import React from 'react';

import Button        from '@material-ui/core/Button';
import Dialog        from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle   from '@material-ui/core/DialogContent';

export default function Confirm(props) {
  return (
    <Dialog open={props.open}
      onClose={props.onDisconfirmed}
    >
      <DialogTitle>
        {props.requestTitle}
      </DialogTitle>
      <DialogContent>
        {props.requestBody}
      </DialogContent>
      <DialogActions>
        <Button onClick={props.onDisconfirmed}>{'취소'}</Button>
        <Button color="primary" onClick={props.onConfirmed}>{'확인'}</Button>
      </DialogActions>
    </Dialog>
  );
}